import axios from "../../../axios"
import { paramsObjToGraphQLParams } from "@/utils/index.js"

export default {
  fetch(queryData) {
    return axios.post('', {
      query: `
        query {
          classifieds ${paramsObjToGraphQLParams(queryData)} {
            order_by,
            pagination_page,
            pagination_limit,
            total_pages,
            items {
              id,
              url,
              created_at,
              activated,
              schedule_publish_at,
            }
          }
        }
      `
    })
  },
  add(classified) {
    return axios.post('', {
      query: `
        mutation {
          createClassified (
            url: "${classified.url}",
            schedule_publish_at: ${classified.schedule_publish_at !== null ? `"${classified.schedule_publish_at}"` : null}
          ) {
            id,
            url,
            created_at,
            activated,
            schedule_publish_at,
          }
        }
      `
    })
  },
  delete(classifiedId) {
    return axios.post('', {
      query: `
        mutation {
          deleteClassified (
            id: ${classifiedId}
          )
        }
      `
    })
  },
  infos(classifiedId) {
    return axios.post('', {
      query: `
        query {
          classifiedInfos (
            id: ${classifiedId}
          ) {
            id,
            url,
            created_at,
            activated,
            schedule_publish_at,
          }
        }
      `
    })
  }
}
